export default __webpack_public_path__ + "static/media/footer-shipping.b3efa0ac.png";